<template>
  <CModal @mtdclosemodal="mtdClose" @mtdRefresh="mtdRefresh" @mtdReset="mtdReset" :show="boo_modal" :title="title"
    :size="'md'" :centered="false" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <CRow>
      <CCol sm="12">
        <v-select v-model="expense.type" :options="types" placeholder="Seleccione un tipo" label="label"
          :close-on-select="true" />
      </CCol>
      <CCol sm="12" class="mt-1">
        <CTextarea label="Motivo de egreso" placeholder="Ingrese el motivo..." rows="3" v-model="expense.motive" />
      </CCol>
      <CCol sm="12" class="mt-1">
        <CInput type="text" label="Monto" v-model="expense.amount" placeholder="Digite monto" @keypress="isNumber()" />
      </CCol>
      <CCol v-for="(item, index) in method" :key="index" sm="4" class="mt-1">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input type="radio" v-model="expense.method" :value="item.id" :aria-label="item.name" />
            </div>
          </div>
          <input type="text" class="form-control" :value="item.name" disabled />
        </div>
      </CCol>
    </CRow>
    <template #footer>
      <button @click="mtdClose" class="btn btn-danger btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="mtd_action" :disabled="cpButton" class="btn btn-info btn-sm">
        <i class="fas fa-save"></i>
        Guardar
      </button>
    </template>
  </CModal>
</template>
<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import { ex } from '@fullcalendar/core/internal-common';

export default {
  name: "c-retirement-deposit-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "expense",
      expense: {
        type: null,
        motive: "",
        method: null,
        amount: ""
      },
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    types: Array,
    method: Array,
  },
  watch: {
    // bead_final(newVal) {
    //   this.bead_final_copy = newVal;
    // },
  },
  computed: {
    cpButton() {
      return (
        !this.expense.type ||
        !this.expense.motive ||
        !this.expense.method ||
        !this.expense.amount
      );
    },
  },
  created() { },
  methods: {
    ...mapActions(["get", "post"]),
    mtdReset() {
      this.$emit("resetData");
    },
    mtdClose() {
      this.resetFormData();
      this.$emit("closeModalExpense");
    },
    mtdRefresh() {
      this.$emit("mtdRefreshData");
    },
    resetFormData() {
      this.expense = {
        type: null,
        motive: "",
        method: null,
        amount: ""
      };
    },
    mtd_action() {
      this.$emit("commitModalExpense", this.expense);
      this.mtdReset();
      this.resetFormData();
      this.mtdRefresh();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped></style>